/** API route map: URLS.Controller.PayrollWCClassification */
export const PayrollWCClassification = {
      Name: 'PayrollJobWcClassificationSetup/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetJobWc: 'get-job-wc',
      GetJobWcemployees: 'get-employees',
};
